import React from "react";
import './Footer.css';

const Footer = () => {
    return (
        <div className="footer-container">
            <a href="https://github.com/aaronsiim"
                className="footer-link"
                target="_blank"
                rel="noreferrer">
                Watch the Github
            </a>
        </div>
    )
}

export default Footer;